import { useAuth } from '../AuthProvider';
import { checkAuthAccess } from '../services/helpers';
import { privateRoutesList } from './PrivateRoutes';

export const useAllowedRoutes = () => {
    const { user } = useAuth();

    const userPermissions = user?.permissions || user?.userPermissions || {};
    const activeServices = user?.allowedServices ||  [];

    const allowedRoutes = privateRoutesList.filter(route => {
        if (route.requiredService) {
            const { isServiceEnabled } = checkAuthAccess({
                activeServices,
                serviceKey: route.requiredService
            });

            if (!isServiceEnabled) return false;
        }

        if (!route.allowedPermissions || route.allowedPermissions.length === 0) {
            return true;
        }

        return route.allowedPermissions.some(permissionKey => {
            const { hasPermission } = checkAuthAccess({
                userPermissions,
                permissionKey,
                action: 'read'
            });

            return hasPermission;
        });
    });

    return allowedRoutes;
};